import * as Sentry from "@sentry/react";

import { bootstrapStacklet } from "./bootstrap";
import { initSentry } from "./initSentry";

interface Renderers {
  /** Draws the application. */
  app: () => void;
  /** Draws a message that the application cannot start. */
  error: () => void;
}

/**
 * Prepares the console, then draws it.
 *
 * Sentry starts first, so that it can report a failure from the steps that
 * follow. Bootstrap reads the deployment config, and it runs ahead of every
 * error boundary in the tree, so a failure there reaches no other handler: the
 * error renderer is the only thing standing between it and an empty page.
 */
export async function startConsole({ app, error }: Renderers): Promise<void> {
  try {
    await initSentry();
    await bootstrapStacklet();
    app();
  } catch (e) {
    Sentry.captureException(e);
    console.error(e);
    error();
  }
}
